import { Controller } from '@hotwired/stimulus';
import { smoothScroll, getWindowHeight } from 'lib/helpers';

export default class ScrollTopController extends Controller {
  connect() {
    this.breakpoint = getWindowHeight() * 3;
    window.addEventListener('scroll', this.checkPosition);
  }

  disconnect() {
    window.removeEventListener('scroll', this.checkPosition);
  }

  checkPosition = () => {
    const top = document.body.scrollTop || document.documentElement.scrollTop;

    if (top > this.breakpoint) {
      this.showScrollTop();
    } else {
      this.hideScrollTop();
    }
  }

  showScrollTop() {
    this.element.classList.add('is-visible');
  }

  hideScrollTop() {
    this.element.classList.remove('is-visible');
  }

  scrollToTop() {
    smoothScroll(0);
  }
}
